import { Box, Divider } from '@mui/material'

import {
  // SFBay Phase II: ManageRecognitionApproval render hidden below — keep import commented for easy restore.
  // ManageRecognitionApproval,
  ManageRecognitionAvailability,
  ManageRecognitionMilestonesTable,
  ManageRecognitionNomination,
  ManageRecognitionOnboarding,
  ManageRecognitionRewards,
  ManageRecognitionTimeframe,
} from '..'

export default function ManageRecognitionAdvanced({ formik, roles, isEditMode }) {
  return (
    <Box>
      <ManageRecognitionRewards formik={formik} roles={roles} />
      <Divider sx={{ my: 3 }} />

      <ManageRecognitionTimeframe formik={formik} />
      <Divider sx={{ my: 3 }} />

      {formik.values.type !== 'birthday' && (
        <>
          <ManageRecognitionAvailability formik={formik} isEditMode={isEditMode} />
          <Divider sx={{ my: 3 }} />
        </>
      )}

      {formik.values.has_nominations && formik.values.has_recurrence && (
        <>
          <ManageRecognitionNomination formik={formik} />
          <Divider sx={{ my: 3 }} />
        </>
      )}

      <ManageRecognitionMilestonesTable formik={formik} />
      {/* <Divider sx={{ my: 3 }} /> */}

      <ManageRecognitionOnboarding formik={formik} />
      {/* SFBay Phase II: Requires Approval hidden — approval workflow is incomplete and toggle is non-functional. */}
      {/* <Divider sx={{ my: 3 }} />

      <ManageRecognitionApproval formik={formik} /> */}
    </Box>
  )
}
